import React, { useState, Component } from 'react';
import { Tag, Check, Clock, Package } from 'lucide-react';
import { offers, Offer } from '../data/offers';
import { WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { OfferModal } from './OfferModal';
export function OffersSection() {
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);
  return <section className="bg-dark-900 py-[80px] px-5 relative" id="ofertas" data-id="element-297" data-mp="b4di97t9wzrv">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#ff3b30] to-transparent" data-id="element-298" data-mp="6628sy6w4ra6" />

      <div className="max-w-[1100px] mx-auto" data-id="element-299" data-mp="jxyw8oxm6d08">
        <div className="inline-flex items-center gap-2 bg-[#ff3b30]/10 border border-[#ff3b30]/40 text-[#ff3b30] px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-[2px] mb-4 mx-auto block w-fit" data-id="element-300" data-mp="jyrzhfxd6kdm">
          <Tag className="w-4 h-4 inline" data-id="element-301" data-mp="3jkor4875c5bk" /> Precios de Liquidación
        </div>

        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white flex items-center justify-center gap-3" data-id="element-302" data-mp="3jim2nsln6k8y">
          <Tag className="w-8 h-8 text-[#ff3b30]" data-id="element-303" data-mp="xm74qq0kfn5o" /> OFERTAS IMPERDIBLES
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-304" data-mp="12dp4xburljpl">
          Hacé click en cualquier oferta para ver todos los detalles y hacer tu
          pedido
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[24px]" data-id="element-305" data-mp="9pjkyrbjbyqt">
          {offers.map(offer => {
          const discount = Math.round((offer.originalPrice - offer.offerPrice) / offer.originalPrice * 100);
          const isCombo = offer.includes.length > 0;
          return <div key={offer.id} onClick={() => setSelectedOffer(offer)} className="bg-dark-800 border-2 border-[#ff3b30]/40 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#ff3b30] hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(255,59,48,0.25)] flex flex-col relative cursor-pointer group" data-id="element-306" data-mp="onvguvr333gx">
                {/* Discount badge */}
                <div className="absolute top-3 right-3 bg-[#ff3b30] text-white text-sm font-black w-12 h-12 rounded-full flex items-center justify-center z-10 shadow-lg rotate-6" data-id="element-307" data-mp="3r8550q5tmktl">
                  -{discount}%
                </div>

                <div className="relative bg-white h-52 flex items-center justify-center p-1 overflow-hidden" data-id="element-308" data-mp="3ddulcn8olgue">
                  <div className="absolute top-3 left-3 bg-[#ff3b30] text-white text-[0.7rem] font-black px-2.5 py-1 rounded-full uppercase tracking-wider z-10 shadow-md flex items-center gap-1" data-id="element-309" data-mp="38gcdl06eh7nz">
                    {isCombo ? <>
                        <Tag className="w-3 h-3" data-id="element-310" data-mp="2tqdhr42bi8bo" /> Combo
                      </> : <>
                        <Package className="w-3 h-3" data-id="element-311" data-mp="2ppl7c7hplxdt" /> Oferta
                      </>}
                  </div>
                  <img src={offer.image} alt={offer.name} className="max-w-full max-h-full object-contain scale-110 transition-transform duration-300 group-hover:scale-[1.18]" data-id="element-312" data-mp="2fja9o8o994a5" />
                </div>

                <div className="p-5 flex flex-col flex-grow" data-id="element-313" data-mp="2amtit6po8btd">
                  <h3 className="text-base font-black text-white mb-3 uppercase tracking-wide leading-tight min-h-[2.5rem]" data-id="element-314" data-mp="2ybm6yh01xfdf">
                    {offer.name}
                  </h3>

                  {isCombo && <ul className="space-y-1.5 mb-4" data-id="element-315" data-mp="2odol205nzunz">
                      {offer.includes.map((item, idx) => <li key={idx} className="flex items-start gap-1.5 text-[#ccc] text-xs font-medium" data-id="element-316" data-mp="2tb8azxbq5vvr" data-mpi={idx}>
                          <Check className="w-3.5 h-3.5 text-[#ff3b30] shrink-0 mt-0.5" data-id="element-317" data-mp="1hxcv2mczxj3h" />
                          <span data-id="element-318" data-mp="1y4r57jkhfen5">{item}</span>
                        </li>)}
                    </ul>}

                  <div className="mt-auto pt-4 border-t border-dark-500 mb-4" data-id="element-319" data-mp="1tby18xwu8ac4">
                    <div className="flex items-end gap-2 mb-2 flex-wrap" data-id="element-320" data-mp="1ofhadvy97hvc">
                      <span className="text-2xl font-black text-[#ff3b30]" data-id="element-321" data-mp="1jfuzht5wedpp">
                        ${offer.offerPrice.toLocaleString('es-UY')}
                      </span>
                      <span className="text-sm text-[#666] line-through font-bold mb-0.5" data-id="element-322" data-mp="2h0qycxp74o8b">
                        ${offer.originalPrice.toLocaleString('es-UY')}
                      </span>
                    </div>
                    <div className="inline-block bg-[#ff3b30]/15 border border-[#ff3b30]/40 text-[#ff7a73] text-[0.7rem] font-bold px-2 py-0.5 rounded" data-id="element-323" data-mp="2262wrumx29xz">
                      AHORRÁS ${offer.savings.toLocaleString('es-UY')}
                    </div>
                  </div>

                  <a href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(offer.waMessage)}`} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold py-3 px-3 rounded-lg flex items-center justify-center gap-2 transition-colors duration-300 mb-3 text-sm" data-id="element-324" data-mp="qss4hb0fkl47">
                    <WhatsAppIcon className="w-4 h-4" data-id="element-325" data-mp="3m1gr4rjezme1" />
                    LO QUIERO
                  </a>

                  <div className="flex items-center justify-center gap-1.5 text-[#ff3b30] text-[0.7rem] font-bold uppercase tracking-wider" data-id="element-326" data-mp="3q1sck6jlpqqk">
                    <Clock className="w-3 h-3" data-id="element-327" data-mp="3w5593u7fkx5" />
                    Stock limitado
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      <OfferModal offer={selectedOffer} onClose={() => setSelectedOffer(null)} data-id="element-328" data-mp="25ni7fl4sfepi" />
    </section>;
}